<div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
  <mat-icon>note_add</mat-icon>
</div>

<div>
  <div class="description">
    <strong>Document Category Verified </strong>
    {{ activity.meta.document.title }} category "{{ documentCategoryDisplay(activity.meta.document.changes.category) }}" verified by Ocrolus
  </div>
</div>
